export default __webpack_public_path__ + "static/fp-text-logo-black-1d1aed27ef13df778631d582d0ecf93b.svg";